import { render } from "./OrderCard.vue?vue&type=template&id=5b655d9d&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=5b655d9d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/thadmin/thadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b655d9d"]])

export default __exports__